import { storage } from './storage';

/** This utility function retrieves a message from storage and replaces placeholders in the message.
 * @param {string} key - The key of the message to retrieve from storage.
 * @param {Object} [placeholders] - An object containing placeholder values to replace in the message.
 * @returns {string} - The parsed message with placeholders replaced, or an empty string if the message is not found.
 * @example
 * Assuming storage contains a message with key 'greeting' as 'Hello, {{name}}!'
 * const message = parseMessage('greeting', { name: 'John' });
 * console.log(message); // Outputs: 'Hello, John!'
 */
export const parseMessage = (key: string, placeholders?: any) => {
  const messages = storage.get('messages');

  if (!messages) return '';
  const _messages = JSON.parse(messages);
  const message: string = _messages[key];

  if (!message) return '';
  
  let parsedMessage = message;
  if (placeholders) {
    // Iterate over the keys in the placeholders object and replace them in the message.
    // Using replaceAll to ensure all instances are replaced.
    Object.keys(placeholders).forEach((key) => {
      parsedMessage = parsedMessage.replaceAll(`{{${key}}}`, placeholders[key]);
    });
  }

  return parsedMessage;
};
